/**
 * G4-T25.7: IndexedDB yerel mağazası — Dexie.js.
 * Çevrimdışı bekleyen sync işlemlerini ve son delta timestamp'ini saklar.
 */
import Dexie from 'dexie';

const db = new Dexie('DataScopeSync');

/**
 * syncQueue tablosu:
 *   id             — auto-increment PK
 *   localId        — istemci tarafı GUID
 *   entityType     — 'Appointment' | 'Order' | ...
 *   entityId       — sunucu tarafı ID (int)
 *   operation      — 'Create' | 'Update' | 'Delete'
 *   payload        — JSON string
 *   clientTimestamp — ISO string
 *   deviceId       — cihaz kimliği
 *   status         — 'pending' | 'sent' | 'conflict'
 *   retries        — tekrar deneme sayısı
 *
 * syncMeta tablosu:
 *   key            — meta veri anahtarı
 *   value          — değer
 */
db.version(1).stores({
  syncQueue: '++id, localId, entityType, entityId, status, clientTimestamp',
  syncMeta:  'key',
});

db.version(2).stores({
  syncQueue:     '++id, localId, entityType, entityId, status, clientTimestamp',
  syncMeta:      'key',
  businessRules: 'id, workflowName, status, modifiedDate',
  productGroups: 'id, textId, updatedDate',
});

export default db;
